import { render, staticRenderFns } from "./EmailChangeDialog.vue?vue&type=template&id=016228f1&scoped=true&"
import script from "./EmailChangeDialog.vue?vue&type=script&lang=js&"
export * from "./EmailChangeDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmailChangeDialog.vue?vue&type=style&index=0&id=016228f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016228f1",
  null
  
)

export default component.exports